module.exports = {
frame:{
    left_position: {
        y: 4,
        x: 0
    },
    bottom_position: {
        y: 186,
        x: 0
    },
    right_position: {
        y: 4,
        x: 186
    },
    top_position: {
        y: 0,
        x: 0
    }
}
};



//////////////////
// WEBPACK FOOTER
// ./cfg/frames-config.js
// module id = 27
// module chunks = 0